import { apiGetFile } from '@/store/api';

export async function getMailAttachments(mailId: string | number, attachments?: { FILE_NAME: string }[]) {
    const attachmentFiles: File[] = [];
    const promises: any[] = [];
    attachments?.forEach((attachment) => {
        promises.push(
            apiGetFile(`mail/${mailId}/download/${attachment.FILE_NAME}`, attachment.FILE_NAME, false).then(
                (result) => {
                    if (result) {
                        const file = new File([result], attachment.FILE_NAME, {
                            type: 'text/plain',
                            lastModified: new Date().getTime(),
                        });
                        attachmentFiles.push(file);
                    }
                }
            )
        );
    });
    await Promise.allSettled(promises);

    return attachmentFiles;
}
